import { apiFetch } from "./fetch-wrapper";
import { getApiUrl } from "../config";

export async function downloadImages(imageIds: string[]): Promise<void> {
  let completedDownloads = 0;
  const totalDownloads = imageIds.length;

  return new Promise((resolve, reject) => {
    let hasError = false;

    imageIds.forEach((itemId, index) => {
      setTimeout(async () => {
        try {
          const response = await apiFetch(`${getApiUrl()}/images/${itemId}/download`, {
            method: "GET",
            headers: {
              "X-Context": "bildebanken",
              "Content-Type": "application/json",
            },
          });
          const data = await response.json();
          const link = document.createElement("a");
          link.href = data.exifEmbeddedHighRes;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error("Error downloading image:", error);
          hasError = true;
        } finally {
          completedDownloads++;
          if (completedDownloads === totalDownloads) {
            if (hasError) {
              reject(new Error("Some downloads failed"));
            } else {
              resolve();
            }
          }
        }
      }, index * 1000);
    });
  });
}
